import React from 'react';
import roll from './roll';
import './RollButton.css';
import './AllButtons.css';

export default function RollButton({players, playersTurn, handleRoll, updateCurrentTotal, gameOver}) {
    let styles = {
        backgroundColor: players[playersTurn].color
    }
    function handleClick() {
        let currentRoll=[roll(),roll()];
        handleRoll(currentRoll);
        updateCurrentTotal(currentRoll);

    }
return (
    <>
    {!gameOver && <button className="Button RollButton" onClick={handleClick} style = {styles}  >{players[playersTurn].name} Roll!</button>}
    </>
  )
}
